import { Dispatch, SetStateAction, createContext, useContext } from 'react';

import { BlockStepManagerState } from './blockStepManager.types';

interface BlockStepManagerContextOutput extends BlockStepManagerState {
	setState: Dispatch<SetStateAction<BlockStepManagerState>>;
}

const initialBlockStepManagerState: BlockStepManagerState = {
	blocks: [],
};

export const initialBlockStepManagerContext: BlockStepManagerContextOutput = {
	...initialBlockStepManagerState,
	setState: () => null,
};

export const BlockStepManagerContext = createContext<BlockStepManagerContextOutput>({
	...initialBlockStepManagerContext,
});

export const useBlockStepManagerContext = (): BlockStepManagerContextOutput => {
	const ctx = useContext(BlockStepManagerContext);
	if (ctx === undefined) {
		throw new Error('useBlockStepManagerContext used outside of BlockStepManagerProvider');
	} else {
		return ctx;
	}
};
